module.exports = __webpack_public_path__ + "img/download.adffac24.svg";